import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import TokenWalletModal from "../../components/TokenWalletModal";
import _ from "lodash";

import "./index.css";

class SuperTokenWallets extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: [],
      tokenWallets: {},
      isLoadingBrands: true,
      isLoadingWallets: false,
    };
  }

  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      let role = this.props.location.state.role;
      if (role !== 0) this.props.history.push("/");
    }

    Firebase.getAllBrands((res) => {
      let brands = res.map((item, index) => ({
        ...item,
        id: index,
      }));
      brands.sort((a, b) => {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      this.setState({ brands, isLoadingBrands: false });
    });

    Firebase.getAllTokenWallets((res) => {
      this.setState({ tokenWallets: res || {}, isLoadingWallets: false });
    });
  }

  getTokenWallet = (brandId) => {
    const { tokenWallets } = this.state;
    const keys = _.keys(tokenWallets);

    const key = keys.find((item) => tokenWallets[item].brandId === brandId);

    if (key) {
      return tokenWallets[key];
    } else {
      return null;
    }
  };

  onSaveTokenWallet = (brandId) => (tokenWallet) => {
    const { tokenWallets } = this.state;
    const ids = _.keys(tokenWallets);

    const id = ids.find((item) => tokenWallets[item].brandId === brandId);

    if (!id) {
      Firebase.createTokenWallet({
        ...tokenWallet,
        brandId,
      });
    } else {
      Firebase.updateTokenWallet(id, {
        ...tokenWallet,
        brandId,
      });
    }
  };

  render() {
    const { logo, brand, isLoadingBrands, isLoadingWallets, brands } =
      this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    const isLoading = isLoadingBrands || isLoadingWallets;

    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main id="main-container">
          <div className="content token-wallets">
            {isLoading ? (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            ) : (
              <div className="token-wallets-container">
                <div className="header-container">
                  <div className="header brand">Brand</div>
                  <div className="header">Live Coin</div>
                  <div className="header">Eco Coin</div>
                  <div className="header">Pot 1</div>
                  <div className="header">Pot 1 Name</div>
                  <div className="header">Pot 2</div>
                  <div className="header">Pot 2 Name</div>
                  <div className="header"></div>
                </div>
                {brands.map((brand) => {
                  const tokenWallet = this.getTokenWallet(brand.id) || {};
                  return (
                    <div className="wallet-items-container" key={brand.id}>
                      <div className="wallet-item brand">{brand.name}</div>
                      <div className="wallet-item">
                        {tokenWallet.liveCoin
                          ? `${tokenWallet.liveCoin}%`
                          : "-"}
                      </div>
                      <div className="wallet-item">
                        {tokenWallet.ecoCoin ? `${tokenWallet.ecoCoin}%` : "-"}
                      </div>
                      <div className="wallet-item">
                        {tokenWallet.pot1 ? `${tokenWallet.pot1}%` : "-"}
                      </div>
                      <div className="wallet-item">
                        {tokenWallet.pot1Name || "-"}
                      </div>
                      <div className="wallet-item">
                        {tokenWallet.pot2 ? `${tokenWallet.pot2}%` : "-"}
                      </div>
                      <div className="wallet-item">
                        {tokenWallet.pot2Name || "-"}
                      </div>
                      <div className="wallet-item">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-toggle="modal"
                          data-target={`#token-wallet-modal-${brand.id}`}
                          onClick={this.onEdit}
                        >
                          Edit
                        </button>
                      </div>
                      <TokenWalletModal
                        id={brand.id}
                        initialValue={tokenWallet}
                        onSave={this.onSaveTokenWallet(brand.id)}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}

export default SuperTokenWallets;



// WEBPACK FOOTER //
// ./src/screens/SuperTokenWallets/index.js